import { create } from 'zustand';

import { ApiUtils } from '@shared/utils';
import { AccountsApi } from '@shared/api/rest';

import { getAccountsResponse } from '@shared/api/rest/accounts';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface AccountType {
  data: getAccountsResponse[];
  loading: boolean;
  error: string | null;
  success: boolean | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetAccountsStore = create<AccountType>((set) => ({
  data: [],
  loading: false,
  error: null,
  success: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await AccountsApi.getAccounts(signal);
      set({ data: result?.data ?? [], loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null, success: null }),
}));
